import { useParams, Navigate } from "react-router-dom";

import {AstrologyFinalStep} from "./astrologyOnboarding/AstrologyFinalStep";


import LawyerOnboardingWrapper from "./lawyerOnboarding/LawyerOnboardingWrapper";

import DoctorOnboarding from "./doctorOnboardng/DoctorOnboardingWrapper";

// import other category flows here

const ExpertOnboarding = () => {
  const { category } = useParams<{ category: string }>();

  if (!category) {
    return <Navigate to="/expert-signup" replace />;
  }

  switch (category) {
    case "astrology":
      return <AstrologyFinalStep />;

    case "lawyer":
      return <LawyerOnboardingWrapper/>;

    case "doctor":
      return <DoctorOnboarding/>;

    default:
      return (
        <div className="p-10 text-center text-gray-600">
          Oops ! Unknown category onboarding, seems like any error GO TO HOMEPAGE
        </div>
      );
  }
};

export default ExpertOnboarding;
